import React,{ useEffect,useState} from "react";
import { Link, Element } from "react-scroll";
import useStores from "stores";
import { observer } from "mobx-react-lite";
import { Table, Tabs,Button } from "@jdcfe/legao";
import style from "./index.module.scss";
import "./index.scss";
import Utils from 'utils/utils.js';

const commonParams = [
  {
    name: "method",
    type: "String",
    required: "是",
    desc: "API接口名称",
    rowKey: "1",
  },
  {
    name: "access_token",
    type: "String",
    required: "是",
    desc: "采用OAuth授权方式为必填参数",
    rowKey: "2",
  },
  {
    name: "app_key",
    type: "String",
    required: "是",
    desc: "应用的app_key",
    rowKey: "3",
  },
  { 
    name: "sign", 
    type: "String", 
    required: "是", 
    desc: "签名", 
    rowKey: "4" 
  },
  {
    name: "timestamp",
    type: "String",
    required: "是",
    desc:
      "时间戳，格式为yyyy-MM-dd HH:mm:ss，例如：2011-06-16 13:23:30。京东API服务端允许客户端请求时间误差为10分钟",
    rowKey: "5",
  },
  {
    name: "format",
    type: "String",
    required: "否",
    desc: "暂时只支持json",
    rowKey: "6",
  },
  { name: "v", type: "String", required: "否", desc: "版本：2.0", rowKey: "7" },
];

function deleteChildren(arr, childrenKey) {
  let childs = arr;
  if (Array.isArray(arr) && arr.length) {
    for (let i = childs.length; i--; i > 0) {
      if (childs[i][childrenKey]) {
        if (childs[i][childrenKey].length) {
          deleteChildren(childs[i][childrenKey], childrenKey);
        } else {
          delete childs[i][childrenKey];
        }
      }
    }
  }

  return arr;
}
function deleteChildren1(arr, childrenKey) {

  let childs = arr;
  if (Array.isArray(arr) && arr.length) {
    for (let i = childs.length; i--; i > 0) {
      
      if (childs[i][childrenKey]) {
        if (childs[i][childrenKey].length) {
          
          deleteChildren1(childs[i][childrenKey], childrenKey);
        } else {
          delete childs[i][childrenKey];
          if(childs[i].systemValue){
            childs.splice(i,1)
          }
          //sourceType为固定值，单独处理
          if( childs[i]?.paramName=="sourceType"){
            childs.splice(i,1)
          }
        }
      }
    }
  }
  // console.log(11)
  // console.log(arr)
  
  return arr;
}


const APIArticleDetail = observer(({ detail,isClick }) => {
  console.log('初始化',isClick)
  if(Utils.getQueryVariable('k') && !isClick){
    const datel = JSON.stringify(detail)
    detail=JSON.parse(Utils.matchSearchKeys(datel,'str',false))

    commonParams.forEach((param,i)=>{
      let tag = JSON.stringify(param)
      commonParams[i] = JSON.parse(Utils.matchSearchKeys(tag,'str',false))
    })
  }
  

  let [show, setShow] = useState(false);
  let [isMatch, setIsMatch] = useState(false);
  let apiInfoDTO = detail && detail.apiInfoDTO ? detail.apiInfoDTO : {};
  let apiGroupDTO=detail && detail.apiGroupDTO ? detail.apiGroupDTO : {};
  let method = detail.method || {};
  let requestParams = method;

  let responseParams = method.josResult || {};
  let errors = detail && detail.apiErrorsDTOS ? detail.apiErrorsDTOS : [];
  let question = detail && detail.matchQuestions ? detail.matchQuestions : [];
  let apiSdkExampleTemplateDTOS =
    detail && detail.apiSdkExampleTemplateDTOS
      ? detail.apiSdkExampleTemplateDTOS
      : [];
      let apiResponseExampleDTO =
    detail && detail.apiResponseExampleDTO ? detail.apiResponseExampleDTO : {};
    let apiErrorResponseExampleDTO =
    detail && detail.apiErrorResponseExampleDTO
      ? detail.apiErrorResponseExampleDTO
      : {};
      let ResponseTabParams = [
    {
      type: "JSON",
      name: "jsonResponseExample",
    },
    {
      type: "XML",
      name: "xmlResponseExample",
    },
  ];
  let ErrorTabParams = [
    {
      type: "JSON",
      name: "jsonErrorExample",
    },
    {
      type: "XML",
      name: "xmlErrorExample",
    },
  ];



  const goApiTest = () => {
    const host = `${window.location.protocol}//${window.location.host}`;
    window.open(host+`/apitest?groupName=${apiGroupDTO.groupName}&&znName=${apiInfoDTO.znName}&&apiName=${apiInfoDTO.apiName}&&apiId=${apiInfoDTO.apiId}`);
  }


  useEffect(()=>{
    // 是否从 搜索进入
    if(Utils.getQueryVariable('k') && !isClick){
      setTimeout(()=>{
        let top = document.getElementsByClassName('searchkey')[0]?document.getElementsByClassName('searchkey')[0].getClientRects()[0].top - 3:0
        window.scrollTo(0,top)
      },1000)
      
    } else {
      if(show) setShow(false)
    }

    setTimeout(()=>{
      setShow(true)
    },500)

  },[detail])

  return (
    <div className={`${style.articleDetail} ${style.api}`} >
      <div className={`${style.detailContent}`}>
        <div className={`${style.detailContentHeader}`}>
          <div className={`${style.title}`} ><span dangerouslySetInnerHTML={{ __html: apiInfoDTO.znName || "" }}></span>
             {/* <span className={`${style.test}`} onClick={()=>goApiTest()} clstag="pageclick|keycount|VopOpenIndex_1602911919488|30">API测试</span> */}
             <Button className={`${style.test}`}  styleType="primary" onClick={()=>goApiTest()}   clstag="pageclick|keycount|VopOpenIndex_1602911919488|30">
                <span className={`lg-btn-text`}>API测试</span>
              </Button>
          </div>

          {apiInfoDTO.apiName && <div className={`${style.methodWay}`}>方法名：{`${apiInfoDTO.apiName}`}</div>}
          
          <div className={`${style.time}`}>
            <img
              className={`${style.icon}`}
              src="https://img13.360buyimg.com/imagetools/jfs/t1/145753/13/11056/509/5f88fe57Ecbf91214/6756de39c356ca23.png"
              alt=""
            />
            <span className={`${style.text}`}>
              {`最后更新日期：${apiInfoDTO.modifiedTime || ""}`}
            </span>
          </div>
        </div>
        <div>
          <Element id="desc">
            <div className={style.section}>
              <div className={style.sectionTitle}>
                使用描述
              </div>
              <div className={style.sectionContent}>
                <div className={style.apiDesc} dangerouslySetInnerHTML={{ __html: apiInfoDTO.apiDesc }}></div>
              </div>
            </div>
          </Element>
          {
            detail && detail.customDesc && (
              <Element id="impact">
                <div className={style.section}>
                  <div className={style.sectionTitle}>
                    未接影响
                  </div>
                  <div className={style.sectionContent}>
                    <div className={style.apiDesc}  dangerouslySetInnerHTML={{ __html: detail.customDesc }}></div>
                  </div>
                </div>
              </Element>
            )
          }
          <Element id="commonParams">
            <div className={`${style.section}`}>
              <div className={`${style.sectionTitle}`}>公共参数</div>
              <div className={`${style.sectionContent}`}>
               {/* eslint-disable */}
                <Table
                  columns={[
                    {
                      title: "名称",
                      dataIndex: "",
                      key: "name",
                      width: 180,
                      render: text => <span dangerouslySetInnerHTML={{ __html: text.name }}></span>
                    },
                    {
                      title: "类型",
                      dataIndex: "",
                      key: "type",
                      width: 120,
                      render: text => <span dangerouslySetInnerHTML={{ __html: text.type }}></span>
                    },
                    {
                      title: "必填",
                      dataIndex: "required",
                      key: "required",
                      width: 120,
                      
                    },
                    { 
                      title: "描述",
                      dataIndex: "", 
                      key: "desc" ,
                      render: text => <span dangerouslySetInnerHTML={{ __html: text.desc }}></span>
                    },
                  ]}
                  data={commonParams}
                  emptyText={"已选条件下暂无数据，请更换筛选条件"}
                />
              </div>
            </div>
          </Element>

          <Element id="requestParams">
            <div className={`${style.section}`}>
              <div className={`${style.sectionTitle}`}>请求参数</div>
              <div className={`${style.sectionContent}`}>
                {
                  show && <Table
                    columns={[
                      {
                        title: "名称",
                        dataIndex: "",
                        key: "paramName",
                        width: 180,
                        render: text => <span dangerouslySetInnerHTML={{ __html: text.paramName }}></span>
                      },
                      {
                        title: "类型",
                        dataIndex: "",
                        key: "type",
                        width: 160,
                        render: text => <span dangerouslySetInnerHTML={{ __html: text.type }}></span>
                      },
                      {
                        title: "必填",
                        dataIndex: "required",
                        key: "required",
                        width: 80,
                        render: value => value ? '是': '否'
                      },
                      {
                        title: "示例值",
                        dataIndex: "",
                        key: "value",
                        width: 80,
                        render: text => <span dangerouslySetInnerHTML={{ __html: text.value }}></span>
                      },
                      { 
                        title: "描述",
                        dataIndex: "",
                        key: "desc" ,
                        render: text => <span dangerouslySetInnerHTML={{ __html: text.desc }}></span>
                      },
                    ]}
                    data={deleteChildren1(requestParams.elements, "elements")}
                    childrenColumnName="elements"
                    defaultExpandAllRows={show}
                    rowKey={(row) => row.paramName}
                    emptyText={"已选条件下暂无数据，请更换筛选条件"}
                  />
                }
                
              </div>
            </div>
          </Element>
        
          <Element name="responseParams">
            <div className={`${style.section}`}>
              <div className={`${style.sectionTitle}`}>响应参数</div>
              <div className={`${style.sectionContent}`}>
                {
                  show && (
                    <Table
                      columns={[
                        {
                          title: "名称",
                          dataIndex: "",
                          key: "paramName",
                          width: 200,
                          render: text => <span dangerouslySetInnerHTML={{ __html: text.paramName }}></span>
                        },
                        {
                          title: "类型",
                          dataIndex: "",
                          key: "type",
                          width: 120,
                          render: text => <span dangerouslySetInnerHTML={{ __html: text.type }}></span>
                        },
                        {
                          title: "示例值",
                          dataIndex: "value",
                          key: "",
                          width: 120,
                          render: text => <span dangerouslySetInnerHTML={{ __html: text.value }}></span>
                        },
                        { 
                          title: "描述", 
                          dataIndex: "", 
                          key: "desc",
                          render: text => <span dangerouslySetInnerHTML={{ __html: text.desc }}></span> },
                      ]}
                      data={deleteChildren(responseParams.elements, "elements")}
                      childrenColumnName="elements"
                      defaultExpandAllRows={show}
                      rowKey={(row) => row.paramName}
                      emptyText={"已选条件下暂无数据，请更换筛选条件"}
                    />
                  )
                }
                
              </div>
            </div>
          </Element>
          <Element name="requestExample">
            <div className={`${style.section}`}>
              <div className={`${style.sectionTitle}`}>请求示例</div>
              <div className={`${style.sectionContent}`}>
                <Tabs
                  prefix={"lg"}
                  type="card"
                  defaultIndex={0}
                  changeEvent={"click"}
                >
                  {apiSdkExampleTemplateDTOS &&
                    apiSdkExampleTemplateDTOS.map((item, index) => (
                      <Tabs.Panel key={index} label={item.type}>
                        <div
                          dangerouslySetInnerHTML={{ __html: item.example }}
                        ></div>
                      </Tabs.Panel>
                    ))}
                </Tabs>
              </div>
            </div>
          </Element>
          <Element name="responseExample">
            <div className={`${style.section}`}>
              <div className={`${style.sectionTitle}`}>响应示例</div>
              <div className={`${style.sectionContent}`}>
                <Tabs
                  prefix={"lg"}
                  type="card"
                  defaultIndex={0}
                  changeEvent={"click"}
                  onChange={(i) => console.log(i)}
                >
                  {ResponseTabParams.map((item, index) => (
                    <Tabs.Panel key={index} label={item.type}>
                      <pre>{apiResponseExampleDTO[item.name]}</pre>
                    </Tabs.Panel>
                  ))}
                </Tabs>
              </div>
            </div>
          </Element>
          <Element name="exceptionExample">
            <div className={`${style.section}`}>
              <div className={`${style.sectionTitle}`}>异常示例</div>
              <div className={`${style.sectionContent}`}>
                <Tabs
                  prefix={"lg"}
                  type="card"
                  defaultIndex={0}
                  changeEvent={"click"}
                  onChange={(i) => console.log(i)}
                >
                  {ErrorTabParams.map((item, index) => (
                    <Tabs.Panel key={index} label={item.type}>
                      <pre dangerouslySetInnerHTML={{ __html: apiErrorResponseExampleDTO[item.name] }}></pre>
                      
                    </Tabs.Panel>
                  ))}
                </Tabs>
              </div>
            </div>
          </Element>
          <Element name="errorExample">
            <div className={`${style.section}`}>
              <div className={`${style.sectionTitle}`}>错误代码示例</div>
              <div className={`${style.sectionContent}`}>
                <Table
                  columns={[
                    {
                      title: "错误码",
                      dataIndex: "code",
                      key: "code",
                      width: 120,
                    },
                    {
                      title: "错误消息",
                      dataIndex: "",
                      key: "error",
                      width: 180,
                      render: text => <span dangerouslySetInnerHTML={{ __html: text.error }}></span>
                    },
                    {
                      title: "解决方案",
                      dataIndex: "",
                      key: "solution",
                      render: text => <span dangerouslySetInnerHTML={{ __html: text.solution }}></span>
                    },
                  ]}
                  data={errors}
                  emptyText={"已选条件下暂无数据，请更换筛选条件"}
                />
              </div>
            </div>
          </Element>
          {
            question && question.length > 0 && (
              <Element name="question">
                <div className={`${style.section}`}>
                  <div className={`${style.sectionTitle}`}>常见问题</div>
                  <div className={`${style.sectionContent}`}>
                    {
                      question.map(item => (
                        <div key={ item.questionContent }>
                          <div dangerouslySetInnerHTML={{ __html: `Q: ${ item.questionTitle }` }}></div>
                          <div className={`${style.questionContent}`} dangerouslySetInnerHTML={{ __html: item.questionContent }}></div>
                        </div>
                      ))
                    }
                  </div>
                </div>
              </Element>
            )
          }
          
        </div>
      </div>
      

      <div className={`${style.anchors}`}>
        <Link
          // containerId="scrollContainer"
          activeClass={style.active}
          className={style.anchorsItem}
          to="desc"
          spy={true}
          smooth={true}
          duration={500}
        >
          使用描述
        </Link>
        {detail && detail.customDesc && (<Link
          // containerId="scrollContainer"
          activeClass={style.active}
          className={style.anchorsItem}
          to="impact"
          spy={true}
          smooth={true}
          duration={500}
        >
          未接影响
        </Link>)}
        <Link
          // containerId="scrollContainer"
          activeClass={style.active}
          className={style.anchorsItem}
          to="commonParams"
          spy={true}
          smooth={true}
          duration={500}
        >
          公共参数
        </Link>
        <Link
          // containerId="scrollContainer"
          activeClass={style.active}
          className={style.anchorsItem}
          to="requestParams"
          spy={true}
          smooth={true}
          duration={500}
        >
          请求参数
        </Link>
        <Link
          // containerId="scrollContainer"
          activeClass={style.active}
          className={style.anchorsItem}
          to="responseParams"
          spy={true}
          smooth={true}
          duration={500}
        >
          响应参数
        </Link>
        <Link
          // containerId="scrollContainer"
          activeClass={style.active}
          className={style.anchorsItem}
          to="requestExample"
          spy={true}
          smooth={true}
          duration={500}
        >
          请求示例
        </Link>
        <Link
          // containerId="scrollContainer"
          activeClass={style.active}
          className={style.anchorsItem}
          to="responseExample"
          spy={true}
          smooth={true}
          duration={500}
        >
          响应示例
        </Link>
        <Link
          // containerId="scrollContainer"
          activeClass={style.active}
          className={style.anchorsItem}
          to="exceptionExample"
          spy={true}
          smooth={true}
          duration={500}
        >
          异常示例
        </Link>
        <Link
          // containerId="scrollContainer"
          activeClass={style.active}
          className={style.anchorsItem}
          to="errorExample"
          spy={true}
          smooth={true}
          duration={500}
        >
          错误示例
        </Link>
        {
          question && question.length > 0 && (
            <Link
              // containerId="scrollContainer"
              activeClass={style.active}
              className={style.anchorsItem}
              to="question"
              spy={true}
              smooth={true}
              duration={500}
            >
              常见问题
            </Link>
          )
        }
        
      </div>
    </div>
  );
});

export default APIArticleDetail;

